import RoadshowIndex from '@rebuild/materials/shared/investment_activity/RoadshowIndex.vue';

export const componentMap = {
	full: RoadshowIndex
};
